import { useCallback } from 'react';
import { dashboardActions } from '../../../../../../../store/slices/dashboardSlice/dashboardSlice';
import { useDispatch } from 'react-redux';

export const useManagerRow = () => {
    const dispatch = useDispatch();

    const onAddManager = useCallback(() => {
        dispatch(dashboardActions.onModalMode('addManager'));
    }, []);
    return { onAddManager };
};
